var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTwitterIconSmall = function SvgTwitterIconSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#3cf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": " ",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M736.8105,666.8184v27.5a3.7509,3.7509,0,0,1-3.75,3.75h-27.5a3.751,3.751,0,0,1-3.75-3.75v-27.5a3.7509,3.7509,0,0,1,3.75-3.75h27.5A3.7509,3.7509,0,0,1,736.8105,666.8184Zm-5,6a10.1941,10.1941,0,0,1-2.9531.7968,5.11,5.11,0,0,0,2.25-2.82,10.04,10.04,0,0,1-3.25,1.2344,5.1348,5.1348,0,0,0-8.7422,4.68,14.5489,14.5489,0,0,1-10.5625-5.3594,5.06,5.06,0,0,0-.6953,2.5859v.0088a5.7131,5.7131,0,0,0,2.2813,4.2569,5.1211,5.1211,0,0,1-2.3125-.6485v.0625a5.1243,5.1243,0,0,0,4.1015,5.0313,5.5227,5.5227,0,0,1-2.3125.0937,5.1307,5.1307,0,0,0,4.7891,3.5547,10.2729,10.2729,0,0,1-6.3594,2.1875,10.7894,10.7894,0,0,1-1.2344-.0625,14.588,14.588,0,0,0,22.4454-12.2812c0-.2188,0-.4453-.0157-.6641A10.7859,10.7859,0,0,0,731.8105,672.8184Z",
    transform: "translate(-701.8105 -663.0684)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterIconSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "twitter-icon-small.03c49409885311d564e9a383272c7107.svg";